module.exports = __webpack_public_path__ + "static/media/header.57a65733.png";